import React, {Component} from 'react';

import style from '../css/counter.css';

class Counter extends Component {

    render() {
        let counterWrapperStyle = this.props.wrapperStyle
            ? this.props.wrapperStyle
            : null;
        let countValue = this.props.count < 100
            ? this.props.count
            : '+99';

        return (
            <div className={counterWrapperStyle} id={this.props.htmlId}>
                <div className={style.counterContainer}>
                    <div className={style.counter}>{countValue}</div>
                </div>
            </div>
        );
    }
}

export default Counter;



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/components/counter.js